import type { CopyShape } from "@tami/core/intl";

import type { CREATORS_SCRIPT_COPY_PT_BR } from "../creators-script.copy";

export const CREATORS_SCRIPT_COPY_EN_US: CopyShape<typeof CREATORS_SCRIPT_COPY_PT_BR> = {
  creatorsIntro: {
    narrative: "The Collab roster: who you manage, how much reach they have and what access they gave you.",
  },
  creatorsSummary: {
    narrative: "Combined reach and overall engagement for the whole roster, plus the seats you've already used.",
    callout: "The size of your Collab in a single number — and how many seats are left.",
  },
  creatorsOverview: {
    narrative: "Creators join by invite and connect their own socials. No spreadsheet in between.",
  },
  creatorsGrid: {
    narrative: "One card per creator: photo, connected socials, followers, engagement and the access they gave you.",
    callout: "Your own Collab is on the roster too — it has its own socials and content.",
  },
  creatorsInvite: {
    narrative: "A pending invite stays visible until the creator accepts — you're not left in the dark waiting.",
    callout: "Sent an invite and they haven't accepted yet? The card stays there, flagged.",
  },
};
